import { render, staticRenderFns } from "./EvaluationEmpty.vue?vue&type=template&id=06f28f92&scoped=true"
import script from "./EvaluationEmpty.vue?vue&type=script&lang=js"
export * from "./EvaluationEmpty.vue?vue&type=script&lang=js"
import style0 from "./EvaluationEmpty.vue?vue&type=style&index=0&id=06f28f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f28f92",
  null
  
)

export default component.exports